import { Toast } from '@/components/Toast'
import { ToastProps } from '@/components/Toast/types'
import { Position, MessageType } from '@/controllers/ToastController/types'
import { FunctionComponent, useMemo } from 'react'
import useStyles from './styles'
import { useSpring, animated } from 'react-spring'
import { ANIMATION_DURATION } from '../constants'

interface SmartToastProps extends ToastProps {
  message: MessageType
  containerPosition: Position
  hide: boolean
}

export const SmartToast: FunctionComponent<SmartToastProps> = ({
  message,
  containerPosition,
  hide,
  ...props
}) => {
  const styles = useStyles()

  const animationPosition = useMemo<'left' | 'right'>(() => {
    if (['top-left', 'bottom-left'].includes(containerPosition)) return 'left'

    return 'right'
  }, [containerPosition])

  const animation = useSpring({
    from: { value: 0 },
    value: 1,
    reverse: hide,
    config: { duration: ANIMATION_DURATION },
  })

  return (
    <animated.div
      css={styles.toastWrapper}
      style={{
        opacity: animation.value,
        [animationPosition]: animation.value.to({
          range: [0, 0.75, 1],
          output: ['-150%', '5%', '0%'],
        }),
      }}
    >
      <Toast {...props} styles={{ root: styles.toastOverride }}>
        {message}
      </Toast>
    </animated.div>
  )
}
